import { type ProspectStage } from "@crowdcoursing/api/openapi";

export interface StageDefinition {
  name: string;
  emoji: string;
  color: string;
}

export const STAGES: Record<ProspectStage, StageDefinition> = {
  0: { color: "#E3F2FD", emoji: "✨", name: "New" }, // Light Blue
  1: { color: "#F3E5F5", emoji: "📞", name: "Contacted" }, // Light Purple
  2: { color: "#FFF9C4", emoji: "📅", name: "Meeting" }, // Light Yellow
  3: { color: "#FFF3E0", emoji: "📝", name: "Proposal" }, // Light Orange
  4: { color: "#FCE4EC", emoji: "🤝", name: "Negotiation" }, // Light Pink
  5: { color: "#E8F5E9", emoji: "🎉", name: "Won" }, // Light Green
  6: { color: "#FFEBEE", emoji: "💔", name: "Lost" }, // Light Red
} as const;
